module.exports = __webpack_public_path__ + "static/media/exclaim.ffd42483.png";